import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx } from "vue"

import { IonApp } from '@ionic/vue'
import { reactive } from 'vue'
import { GroupEnum } from './assets/interfaces'
import Tabs from './components/Tabs.vue'
import Groups from './views/Groups.vue'
import Playoffs from './views/Playoffs.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const state = reactive({
	currentPage: 'groups',
	participants: 3,
	currentSegment: GroupEnum.fourThree,
	qualifiers: 4,
	amount: 2,
	direct: 0
})

const setPage = (name: string) => {
	state.currentPage = name
}

const setParticipants = (participants: number) => {
	state.participants = participants
}

const setSegment = (segment: GroupEnum) => {
	state.currentSegment = segment
}

const setAmount = (amount: number) => {
	state.amount = amount
}

const setQualifiers = (qualifiers: number) => {
	state.qualifiers = Math.max(qualifiers, 4)
}

const setDirect = (direct: number) => {
	state.direct = direct
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      (state.currentPage === 'groups')
        ? (_openBlock(), _createBlock(Groups, {
            key: 0,
            participants: state.participants,
            segment: state.currentSegment,
            amount: state.amount,
            onSetParticipants: setParticipants,
            onSetSegment: setSegment,
            onSetQualifier: setQualifiers,
            onSetAmount: setAmount
          }, null, 8, ["participants", "segment", "amount"]))
        : (_openBlock(), _createBlock(Playoffs, {
            key: 1,
            qualifiers: state.qualifiers,
            onSetQualifiers: setQualifiers,
            direct: state.direct,
            onSetDirect: setDirect
          }, null, 8, ["qualifiers", "direct"])),
      _createVNode(Tabs, {
        class: "pb-safe",
        current: state.currentPage,
        onSetPage: setPage
      }, null, 8, ["current"])
    ]),
    _: 1
  }))
}
}

})